import clsx from 'clsx'
import type { DataTableHeader, DataTableInstance, DataTableRowData } from '../../types'

interface Props<TData extends DataTableRowData> {
  header: DataTableHeader<TData>
  table: DataTableInstance<TData>
}

export const TableHeadCellResizeHandle = <TData extends DataTableRowData>({
  header,
  table,
}: Props<TData>) => {
  const {
    getState,
    options: { columnResizeMode },
    setColumnSizingInfo,
  } = table
  const { column } = header
  const handler = header.getResizeHandler()

  const offset =
    column.getIsResizing() && columnResizeMode === 'onEnd'
      ? `translateX(${1 * (getState().columnSizingInfo.deltaOffset ?? 0)}px)`
      : undefined

  const handleDoubleClick = () => {
    setColumnSizingInfo((old) => ({
      ...old,
      isResizingColumn: false,
    }))
    column.resetSize()
  }

  return (
    <div
      onDoubleClick={handleDoubleClick}
      onMouseDown={handler}
      onTouchStart={handler}
      role="separator"
      className={clsx(
        'mrt-table-head-cell-resize-handle',
        'bg-tertiary rounded-sm cursor-col-resize h-6 absolute w-1 hover:bg-brand active:bg-brand',
        'right-0 -mr-2.5',
        !header.subHeaders.length && columnResizeMode === 'onChange' && 'active:opacity-0',
      )}
      style={{
        transform: offset,
      }}
    />
  )
}
